<template>
  <SidebarMenu>
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenuItem>
          <SidebarMenuButton :variant="$route.name === 'home' ? 'active' : 'default'" @click="handleNavigation('home')">
            <Heart class="tw-w-4 tw-h-4 tw-mr-2" />
            <span>Benefits</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem v-if="hasHealthWalletAccess">
          <SidebarMenuButton
            :variant="
              $route.name === 'health-wallet' || $route.name === 'health-wallet-redirect' ? 'active' : 'default'
            "
            @click="handleNavigation('health-wallet')"
          >
            <Wallet class="tw-w-4 tw-h-4 tw-mr-2" />
            <span>Health wallet</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarGroupContent>
    </SidebarGroup>
  </SidebarMenu>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router"
import { Heart, Wallet } from "lucide-vue-next"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem
} from "@/components/ui/sidebar"
import { useUserStore } from "@/store/user-store"
import { useMemberProfile } from "@/composables/member-profile"
import { storeToRefs } from "pinia"

const emit = defineEmits<{
  navigate: [route: string]
}>()

const router = useRouter()
const $route = useRoute()
const userStore = useUserStore()
const { user } = storeToRefs(userStore)

const { hasHealthWalletAccess } = useMemberProfile(user.value?.member?.id || "")

function handleNavigation(route: string) {
  if (route === "health-wallet") {
    router.push("/health-wallet")
  } else {
    router.push({ name: route })
  }
  emit("navigate", route)
}
</script>
